import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-691c192f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OTabelaProjetos",
  "data-testid": "OTabelaProjetos"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Limpar ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Aplicar ")
const _hoisted_5 = { class: "OTabelaProjetos__GrupoBotoes" }

import { ref, reactive, onMounted, computed } from "vue"
  import { useRouter } from "vue-router"
  import {
    IAlertaMensagem,
    MModalDeAlerta,
    OGrupoAvatar,
    AAmostraDeCor,
    MInput,
    MMultiSelect,
    AEstadoVazioTabela,
    APaginadorDeTabela,
  } from "@/components/Gerais"
  import Column from "primevue/column"
  import DataTable, { DataTableFilterMeta } from "primevue/datatable"
  import PButton from "primevue/button"
  import {
    COR_PADRAO_PROJETO,
    ListarProjetos,
    ParamsProjeto,
  } from "@/repositorios/projeto/projeto.modelo"
  import ProjetoRepositorio from "@/repositorios/projeto/projeto.repositorio"

  import { usarManipuladoresDeTabela } from "@/composable/UsarManipuladoresDeTabela/usarManipuladoresDeTabela"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento"

  import tabelaProjetos from "./OTabelaProjetos.script"
  import { useToast } from "primevue/usetoast"
  import UsuariosRepositorio from "@/repositorios/usuarios/usuarios.repositorio"
  import { Anulavel, EntidadeGenerica } from "@/types/gerais"
  import { usarFiltragem } from "@/composable/UsarFiltragem"
  import SessaoServico from "@/servicos/sessao.service"
  import { OperacaoDePermissionamento } from "@/composable/UsarPermissionamento/modulosDePermissao"
  import { PageState } from "primevue/paginator"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { useI18n } from "vue-i18n"

  interface AlertaComReset extends IAlertaMensagem {
    $reset(): void
    legendaBotaoPositivo?: string
    acaoBotaoPositivo?: () => void
    legendaBotaoNeutro?: string
    acaoBotaoNeutro?: () => void
    legendaBotaoNegativo?: string
    acaoBotaoNegativo?: () => void
    icone: string
  }

  interface Props {
    idGrupoDeProjetos: Anulavel<string>
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OTabelaProjetos',
  props: {
    idGrupoDeProjetos: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
    idGrupoDeProjetos: Anulavel<string>
  }

  

  const { t } = useI18n()

  const PRIMEIRA_PAGINA_PADRAO = 0
  const ALTURA_RELATIVA_DA_TABELA = ref("230px")

  const { onErro } = usarMensagemUsuario()
  const { verificarPermissaoPorGrupo } = usarPermissionamento("Projetos")
  const { filtros, preencherFiltro, removerFiltro } = usarFiltragem()
  const { desativarLinhaPorStatus } = usarManipuladoresDeTabela()
  const projetoRep = new ProjetoRepositorio()
  const { filtrosTabela } = tabelaProjetos()
  const toast = useToast()
  const projetos = ref<ListarProjetos[]>([])
  const linhasExpandidas = ref([])
  const router = useRouter()
  const { leitor } = usarLeitorDeDados()
  const idUsuarioLogado: string =
    SessaoServico.coletarInformacoesDoUsuarioLogado().id

  const verificarPermissaoNoProjeto = (
    permissao: OperacaoDePermissionamento
  ): boolean => {
    return verificarPermissaoPorGrupo(permissao, "outros")
  }

  const verificarSeUsuarioPodeAgirSobreProjeto = (
    projeto: ListarProjetos,
    permissao: OperacaoDePermissionamento
  ): boolean => {
    return (
      verificarSeUsuarioEhResponsavelPeloProjeto(projeto) ||
      verificarPermissaoNoProjeto(permissao)
    )
  }

  const verificarSeUsuarioEhResponsavelPeloProjeto = (
    projeto: ListarProjetos
  ): boolean => {
    const usuarioExisteNoProjeto: boolean = projeto.usuariosResponsaveis.some(
      (usuarioId: string): boolean => usuarioId === idUsuarioLogado
    )
    return usuarioExisteNoProjeto
  }

  const lerProjetos = leitor<ListarProjetos, ParamsProjeto>(
    projetoRep.listarProjetosFrontend
  )
  const usuariosResponsaveisOpcoes = ref<EntidadeGenerica[]>([])

  const objetoDialog = reactive<AlertaComReset>({
    titulo: "",
    icone: "pi pi-exclamation-triangle",
    tipo: "padrao",
    visivel: false,
    conteudo: "",
    $reset: function () {
      this.visivel = false
      this.titulo = ""
      this.icone = ""
      this.conteudo = ""
    },
  })

  const carregandoProjetos = computed(() => {
    return lerProjetos.resultado.status === "pendente"
  })
  const fecharModal = () => {
    objetoDialog.$reset()
  }

  const listarProjetos = async (pagina: number, porPagina = 10) => {
    await lerProjetos.porPagina(porPagina).pagina(pagina).executar()
    const statusDaRequisicao = lerProjetos.resultado.status

    if (statusDaRequisicao === "vazio") {
      projetos.value = []
    } else if (statusDaRequisicao === "sucesso") {
      projetos.value = lerProjetos.resultado.dados
    } else if (statusDaRequisicao === "erro") {
      onErro({
        resumo: t("ocorreuUmErroAoBuscarOsProjetos"),
        detalhes: t("tenteNovamenteMaisTarde"),
      })
    }
  }
  const aplicarFiltros = async (
    dadosDoPreenchimentoDoFiltro: Record<string, any>,
    nomeDaColunaNaAPI: string
  ) => {
    const { matchMode, value } = (
      dadosDoPreenchimentoDoFiltro as DataTableFilterMeta
    ).constraints[0]
    preencherFiltro(nomeDaColunaNaAPI, matchMode, value)
    await lidarComBuscaDeProjetos(props.idGrupoDeProjetos)
  }

  const limparFiltros = async (nome, filterCallback) => {
    removerFiltro(nome)
    filterCallback()
    await lidarComBuscaDeProjetos(props.idGrupoDeProjetos)
  }

  const onPaginarProjetos = async ({ page, rows }: PageState) => {
    await listarProjetos(page, rows)
  }
  const atualizarTabela = async () => {
    await listarProjetos(lerProjetos.paginaAtual)
    fecharModal()
  }

  const acaoArquivarProjeto = async (projeto: ListarProjetos) => {
    try {
      const id = projeto.id
      await projetoRep.arquivarProjeto(id)
      toast.add({
        severity: "success",
        summary: t("sucesso"),
        detail: t("projetosArquivado"),
        life: 4000,
      })
    } catch (erro) {
      toast.add({
        severity: "error",
        summary: t("erro"),
        detail: t("naoFoiPossivelArquivarProjeto"),
        closable: true,
        life: 3000,
      })
    } finally {
      atualizarTabela()
    }
  }

  const acaoDesarquivarProjeto = async (projeto: ListarProjetos) => {
    try {
      const id = projeto.id
      await projetoRep.desarquivarProjeto(id)
      toast.add({
        severity: "success",
        summary: t("sucesso"),
        detail: t("projetoDesarquivado"),
        life: 4000,
      })
    } catch (erro) {
      toast.add({
        severity: "error",
        summary: t("erro"),
        detail: t("naoFoiPossivelDesarquivarProjeto"),
        closable: true,
        life: 3000,
      })
    } finally {
      atualizarTabela()
    }
  }

  const acaoDeletarProjeto = async (projeto: ListarProjetos) => {
    try {
      const id = projeto.id
      await projetoRep.deletarProjeto(id)
      toast.add({
        severity: "success",
        summary: t("sucesso"),
        detail: t("projetoDeletado"),
        life: 4000,
      })
    } catch (erro) {
      toast.add({
        severity: "error",
        summary: t("erro"),
        detail: t("naoFoiPossivelDeletarProjeto"),
        closable: true,
        life: 3000,
      })
    } finally {
      atualizarTabela()
    }
  }

  const deletarProjeto = async (projeto: ListarProjetos) => {
    objetoDialog.titulo = `${t("deletar")} "${projeto.nomeProjeto}"?`
    objetoDialog.conteudo = t("projetoSeraPermanentementeRemovido")
    objetoDialog.icone = "pi pi-exclamation-triangle"
    objetoDialog.visivel = true
    objetoDialog.legendaBotaoNeutro = t("voltar")
    objetoDialog.legendaBotaoPositivo = t("simExcluir")
    objetoDialog.acaoBotaoPositivo = () => acaoDeletarProjeto(projeto)
  }

  const editarProjeto = (projeto: ListarProjetos) => {
    const id = projeto.id
    router.push(`/novo-projeto/${id}`)
  }

  const buscarPorUsuariosResponsaveis = async () => {
    const usuariosRep = new UsuariosRepositorio()
    const dados = await usuariosRep.listarUsuarios({ "por-pagina": "1000" })
    usuariosResponsaveisOpcoes.value = dados.resultados.map((dado) => ({
      id: dado["id"],
      nome: dado["nome"],
    }))
  }

  const lidarComBuscaDeProjetos = async (
    idGrupo: Anulavel<string> = null
  ): Promise<void> => {
    const listarTodosOsProjetos = !idGrupo || idGrupo === "sem-grupo"
    lerProjetos.primeiraPagina = PRIMEIRA_PAGINA_PADRAO

    if (listarTodosOsProjetos) {
      definirAlturaDaTabelaSemGrupo()
      await buscarSemGrupo()
      return
    }
    definirAlturaDaTabelaComGrupo()
    await buscarPorGrupo(idGrupo)
  }

  const buscarSemGrupo = async (): Promise<void> => {
    lerProjetos.sobrescreverParametros({
      ...filtros.value,
    })
    await listarProjetos(lerProjetos.primeiraPagina, lerProjetos.itensPorPagina)
  }

  const buscarPorGrupo = async (idGrupo: string): Promise<void> => {
    lerProjetos.sobrescreverParametros({
      ...filtros.value,
      grupo_de_projetos: `igual.${idGrupo}`,
    })
    await listarProjetos(lerProjetos.primeiraPagina, lerProjetos.itensPorPagina)
  }

  const definirAlturaDaTabelaComGrupo = (): void => {
    ALTURA_RELATIVA_DA_TABELA.value = "320px"
  }

  const definirAlturaDaTabelaSemGrupo = (): void => {
    ALTURA_RELATIVA_DA_TABELA.value = "230px"
  }

  onMounted(async () => {
    try {
      await buscarPorUsuariosResponsaveis()
    } catch (erro) {
      console.error(erro)
    }
  })

  expose({
    lidarComBuscaDeProjetos,
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DataTable), {
      expandedRows: linhasExpandidas.value,
      "onUpdate:expandedRows": _cache[0] || (_cache[0] = ($event: any) => ((linhasExpandidas).value = $event)),
      filters: _unref(filtrosTabela),
      "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_isRef(filtrosTabela) ? (filtrosTabela).value = $event : null)),
      class: "p-datatable-sm",
      "data-key": "codigo",
      "data-testid": "OTabelaProjetos__DataTable",
      "filter-display": "menu",
      "global-filter-fields": ['nomeProjeto', 'codigo', 'usuariosResponsaveis'],
      loading: _unref(carregandoProjetos),
      "responsive-layout": "scroll",
      "row-class": _unref(desativarLinhaPorStatus),
      rows: _unref(lerProjetos).itensPorPagina,
      "scroll-height": `calc(100vh - ${ALTURA_RELATIVA_DA_TABELA.value})`,
      scrollable: "",
      "striped-rows": "",
      value: projetos.value
    }, _createSlots({
      loading: _withCtx(() => [
        _createVNode(_component_Skeleton, {
          height: "100%",
          width: "100%"
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(APaginadorDeTabela), {
          "ao-paginar": onPaginarProjetos,
          leitor: _unref(lerProjetos)
        }, null, 8, ["leitor"])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          class: "OTabelaProjetos__Column OTabelaProjetos__CorHexadecimal",
          field: "corHexadecimal",
          header: "",
          style: {"flex":"0"}
        }, {
          body: _withCtx(({ data: projeto }) => [
            _createVNode(_unref(AAmostraDeCor), {
              cor: projeto.corHexadecimal ?? _unref(COR_PADRAO_PROJETO)
            }, null, 8, ["cor"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          class: "OTabelaProjetos__Column OTabelaProjetos__Nome",
          field: "nomeProjeto",
          "filter-field": "nome_projeto",
          header: _unref(t)('nome'),
          "show-add-button": false,
          "show-filter-operator": false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", {
              class: "quebrar-texto-em-duas-linhas",
              "data-testid": "OTabelaProjetos__Dado",
              title: data.nomeProjeto
            }, _toDisplayString(data.nomeProjeto), 9, _hoisted_2)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_unref(MInput), {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              nome: "filtro-nome-do-projeto",
              placeholder: _unref(t)('pesquisar por nome do projeto'),
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (limparFiltros('nome_projeto', filterCallback))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          filterapply: _withCtx(({ filterModel, field }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (aplicarFiltros(filterModel, field))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          class: "OTabelaProjetos__Column OTabelaProjetos__Codigo",
          field: "codigo",
          "filter-field": "codigo",
          header: _unref(t)('codigo'),
          "show-add-button": false,
          "show-filter-operator": false
        }, {
          body: _withCtx(({ data: projeto }) => [
            _createTextVNode(_toDisplayString(projeto.codigo), 1)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_unref(MInput), {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              nome: "filtro-codigo",
              placeholder: _unref(t)('pesquisarPorCodigoDoProjeto'),
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          filterclear: _withCtx(({ field, filterCallback }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (limparFiltros(field, filterCallback))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          filterapply: _withCtx(({ filterModel, field }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (aplicarFiltros(filterModel, field))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          class: "OTabelaProjetos__Column OTabelaProjetos__UsuariosResponsaveis",
          "data-type": "multiselect",
          field: "usuariosResponsaveis",
          "filter-field": "usuarios_responsaveis",
          header: _unref(t)('usuariosResponsaveis'),
          "show-add-button": false,
          "show-filter-match-modes": false,
          "show-filter-operator": false
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(OGrupoAvatar), {
              identificadores: data.usuariosResponsaveis,
              "limitar-quantidade-em": 15,
              "requisitar-avatares-por-id": ""
            }, null, 8, ["identificadores"])
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_unref(MMultiSelect), {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "OAcordeaoProjetos__MMultiselect",
              "exibicao-de-opcoes": "comma",
              filter: true,
              "maximo-de-legendas-selecionadas": 3,
              nome: "filtro-usuarios-responsaveis",
              "option-label": "nome",
              "option-value": "id",
              options: usuariosResponsaveisOpcoes.value,
              placeholder: _unref(t)('pesquisarPorUsuarioResponsavel')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])
          ]),
          filterclear: _withCtx(({ field, filterCallback }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (limparFiltros(field, filterCallback))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          filterapply: _withCtx(({ filterModel, field }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (aplicarFiltros(filterModel, field))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          class: "OTabelaProjetos__Column OTabelaProjetos__Actions",
          field: "acoes",
          header: "",
          style: {"flex":"0"}
        }, {
          body: _withCtx(({ data: projeto }) => [
            _createElementVNode("div", _hoisted_5, [
              (verificarSeUsuarioPodeAgirSobreProjeto(projeto, 'editar'))
                ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                    key: 0,
                    onClick: ($event: any) => (editarProjeto(projeto)),
                    class: "OTabelaProjetos__Botao p-button-rounded",
                    "data-testid": "OTabelaProjetos__IButton",
                    icon: "pi pi-pencil"
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _unref(t)('editar'),
                      void 0,
                      { top: true }
                    ]
                  ])
                : _createCommentVNode("", true),
              (
                projeto.ativo &&
                  verificarSeUsuarioPodeAgirSobreProjeto(projeto, 'arquivar')
              )
                ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                    key: 1,
                    onClick: ($event: any) => (acaoArquivarProjeto(projeto)),
                    class: "OTabelaProjetos__Botao p-button-rounded",
                    "data-testid": "OTabelaProjetos__Arquivar",
                    icon: "pi pi-eye-slash"
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _unref(t)('arquivar'),
                      void 0,
                      { top: true }
                    ]
                  ])
                : _createCommentVNode("", true),
              (
                !projeto.ativo &&
                  verificarSeUsuarioPodeAgirSobreProjeto(projeto, 'desarquivar')
              )
                ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                    key: 2,
                    onClick: ($event: any) => (acaoDesarquivarProjeto(projeto)),
                    class: "OTabelaProjetos__Botao p-button-rounded",
                    "data-testid": "OTabelaProjetos__IButton",
                    icon: "pi pi-eye"
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _unref(t)('desarquivar'),
                      void 0,
                      { top: true }
                    ]
                  ])
                : _createCommentVNode("", true),
              (
                !projeto.ativo &&
                  verificarSeUsuarioPodeAgirSobreProjeto(projeto, 'deletar')
              )
                ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                    key: 3,
                    onClick: ($event: any) => (deletarProjeto(projeto)),
                    class: "OTabelaProjetos__Botao p-button-rounded",
                    "data-testid": "OTabelaProjetos__Deletar",
                    icon: "pi pi-trash"
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _unref(t)('excluir'),
                      void 0,
                      { top: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 2
    }, [
      (!_unref(carregandoProjetos))
        ? {
            name: "empty",
            fn: _withCtx(() => [
              _createVNode(_unref(AEstadoVazioTabela))
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["expandedRows", "filters", "loading", "row-class", "rows", "scroll-height", "value"]),
    _createVNode(_unref(MModalDeAlerta), {
      modelValue: objetoDialog.visivel,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((objetoDialog.visivel) = $event)),
      cabecalho: objetoDialog.titulo,
      icone: objetoDialog.icone,
      tipo: objetoDialog.tipo
    }, {
      conteudo: _withCtx(() => [
        _createTextVNode(_toDisplayString(objetoDialog.conteudo), 1)
      ]),
      acoes: _withCtx(() => [
        _createVNode(_unref(PButton), {
          onClick: fecharModal,
          class: "Modal__Button p-button-text p-button-info",
          label: objetoDialog.legendaBotaoNeutro
        }, null, 8, ["label"]),
        _createVNode(_unref(PButton), {
          onClick: _cache[2] || (_cache[2] = () => objetoDialog.acaoBotaoPositivo?.()),
          class: "Modal__Button p-button-danger",
          label: objetoDialog.legendaBotaoPositivo
        }, null, 8, ["label"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(objetoDialog.conteudo), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "cabecalho", "icone", "tipo"])
  ]))
}
}

})